// In-memory TTL cache for API responses.
// Lives in module scope — resets on page load, making cross-user leakage impossible.
const store = new Map();

export const cacheGet = (key) => {
  const entry = store.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    store.delete(key);
    return null;
  }
  return entry.value;
};

export const cacheSet = (key, value, ttlSeconds) => {
  store.set(key, { value, expiresAt: Date.now() + ttlSeconds * 1000 });
};

export const cacheDel = (key) => store.delete(key);

export const cacheDelByPrefix = (prefix) => {
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) store.delete(key);
  }
};

// Call on login and logout to prevent cross-session data leakage
export const cacheClear = () => store.clear();
